import { SpeakerLabelTextInterface } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Element/VideoElement';

export default function SpeakerLabelText({ element }: { element: SpeakerLabelTextInterface }) {
  return <div style={element?.style}>{element?.content}</div>;
}
